/* Success Systems — filtered collection Previous/Next navigation.
   Fetches only nearby collection pages, never unrelated products. */
(() => {
  if (window.__lucyBrowseNavigationLoaded) return;
  window.__lucyBrowseNavigationLoaded = true;

  const CONTEXT_KEY = 'lucy_browse_context_v2';
  const CACHE_KEY = 'lucy_browse_page_cache_v2';
  const MARKER = 'ss_browse';
  const PAGE = 'ss_page';
  const POSITION = 'ss_pos';

  function productHandle(input) {
    try {
      const match = new URL(input, location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) { return null; }
  }
  function get(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (_) { return null; } }
  function set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); return true; } catch (_) { return false; } }

  function titleForCollection(title, url) {
    const chosen = [];
    for (const [key, value] of new URL(url).searchParams.entries()) {
      if (!key.startsWith('filter.') || !value) continue;
      if (key.includes('.price.')) {
        if (!chosen.includes('Price Filter')) chosen.push('Price Filter');
      } else {
        value.split(',').forEach(v => { if (v.trim() && !chosen.includes(v.trim())) chosen.push(v.trim()); });
      }
    }
    const all = /^(all|all products|products|brand products)$/i.test(title.trim());
    if (!chosen.length) return all ? 'All' : title;
    return (all ? [] : [title]).concat(chosen.filter(v => v.toLowerCase() !== title.toLowerCase())).join(' + ');
  }

  function rowsIn(grid) {
    const rows = [];
    const seen = new Set();
    for (const card of grid.querySelectorAll('li.grid__item')) {
      const link = card.querySelector('.card__heading a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      const handle = productHandle(link.href);
      if (!handle || seen.has(handle)) continue;
      seen.add(handle);
      rows.push({ handle, url: new URL(link.href, location.origin).pathname, title: (link.textContent || '').trim() });
    }
    return rows;
  }

  function signature(ctx) { return [ctx.url, ctx.sectionId, ctx.count, ctx.perPage].join('|'); }
  function cachePage(ctx, number, rows) {
    if (!number || !Array.isArray(rows)) return;
    const cache = get(CACHE_KEY);
    const current = cache && cache.signature === signature(ctx) ? cache : {signature: signature(ctx), pages: {}};
    current.pages[number] = rows;
    set(CACHE_KEY, current);
  }
  async function getPage(ctx, number) {
    if (number < 1 || number > Math.ceil(ctx.count / ctx.perPage)) return [];
    const cached = get(CACHE_KEY);
    if (cached && cached.signature === signature(ctx) && cached.pages && Array.isArray(cached.pages[number])) {
      return cached.pages[number];
    }
    const url = new URL(ctx.url, location.origin);
    url.searchParams.set('page', String(number));
    url.searchParams.set('section_id', ctx.sectionId);
    const response = await fetch(url.toString(), {credentials: 'same-origin'});
    if (!response.ok) throw Error('Could not load collection page ' + number);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const grid = html.querySelector('#product-grid');
    if (!grid) throw Error('Collection product grid not returned');
    const rows = rowsIn(grid);
    if (!rows.length) throw Error('Collection page contains no products');
    cachePage(ctx, number, rows);
    return rows;
  }

  // Capture clicks on the live Shopify collection grid, including AJAX-filtered views.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const element = event.target.nodeType === 1 ? event.target : event.target.parentElement;
    const anchor = element && element.closest('a[href]');
    const card = anchor && anchor.closest('li.grid__item');
    const grid = card && card.closest('#product-grid');
    if (!grid || !anchor || !productHandle(anchor.href) || (anchor.target && anchor.target !== '_self')) return;
    if (!location.pathname.includes('/collections/')) return;
    const count = Number(grid.dataset.lucyNavTotal);
    const perPage = Number(grid.dataset.lucyNavPageSize);
    const sectionId = grid.dataset.id;
    if (!Number.isFinite(count) || count < 1 || !perPage || !sectionId) return;

    const url = new URL(location.href);
    const page = Math.max(1, Number(url.searchParams.get('page')) || 1);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    const ctx = {
      url: url.pathname + url.search, sectionId, count, perPage,
      label: titleForCollection(grid.dataset.lucyNavTitle || 'Products', url.href), stamp: Date.now()
    };
    const rows = rowsIn(grid);
    const pos = rows.findIndex(row => row.handle === productHandle(anchor.href));
    if (pos < 0 || !set(CONTEXT_KEY, ctx)) return;
    cachePage(ctx, page, rows);
    const destination = new URL(anchor.href);
    destination.searchParams.set(MARKER, String(ctx.stamp));
    destination.searchParams.set(PAGE, String(page));
    destination.searchParams.set(POSITION, String(pos));
    anchor.href = destination.href;
  }, true);

  function linkFor(row, ctx, page, pos) {
    const url = new URL(row.url, location.origin);
    url.searchParams.set(MARKER, String(ctx.stamp));
    url.searchParams.set(PAGE, String(page));
    url.searchParams.set(POSITION, String(pos));
    return url.pathname + url.search;
  }
  function renderLink(nav, selector, choice, label, ctx) {
    const el = nav.querySelector(selector);
    if (!el) return;
    const prefix = el.querySelector('.lucy-browse-nav__label');
    const name = el.querySelector('.lucy-browse-nav__name');
    if (prefix) prefix.textContent = label.toUpperCase() + ':';
    if (choice && choice.row) {
      el.href = linkFor(choice.row, ctx, choice.page, choice.pos);
      el.classList.remove('lucy-browse-nav__link--disabled');
      el.removeAttribute('aria-disabled');
      if (name) name.textContent = choice.row.title || choice.row.handle;
    } else {
      el.removeAttribute('href');
      el.classList.add('lucy-browse-nav__link--disabled');
      el.setAttribute('aria-disabled', 'true');
      if (name) name.textContent = 'None';
    }
    el.hidden = false;
  }
  async function init() {
    const nav = document.querySelector('[data-lucy-browse-product]');
    if (!nav) return;
    const url = new URL(location.href);
    const ctx = get(CONTEXT_KEY);
    const marker = url.searchParams.get(MARKER);
    if (!marker || !ctx || String(ctx.stamp) !== marker || Date.now() - ctx.stamp > 86400000) return;
    const page = Number(url.searchParams.get(PAGE));
    const pos = Number(url.searchParams.get(POSITION));
    if (!Number.isInteger(page) || page < 1 || !Number.isInteger(pos) || pos < 0) return;
    try {
      const rows = await getPage(ctx, page);
      const current = productHandle(nav.dataset.lucyBrowseProduct);
      if (!rows[pos] || rows[pos].handle !== current) throw Error('Selected product does not match the filtered results');
      let previous = pos > 0 ? {row: rows[pos - 1], page, pos: pos - 1} : null;
      let next = pos < rows.length - 1 ? {row: rows[pos + 1], page, pos: pos + 1} : null;
      if (!previous && page > 1) {
        const before = await getPage(ctx, page - 1);
        if (before.length) previous = {row: before[before.length - 1], page: page - 1, pos: before.length - 1};
      }
      if (!next && page < Math.ceil(ctx.count / ctx.perPage)) {
        const after = await getPage(ctx, page + 1);
        if (after.length) next = {row: after[0], page: page + 1, pos: 0};
      }
      const heading = nav.querySelector('.lucy-browse-nav__heading');
      const count = nav.querySelector('.lucy-browse-nav__count');
      if (heading) heading.textContent = `You Are Browsing ${ctx.label} Products`;
      if (count) count.textContent = `(${ctx.count} matching products)`;
      renderLink(nav, '[data-lucy-browse-prev]', previous, 'Previous', ctx);
      renderLink(nav, '[data-lucy-browse-next]', next, 'Next', ctx);
      nav.hidden = false;
    } catch (error) {
      // Never show unrelated products if the filtered collection cannot be verified.
      console.warn('Browsing navigation unavailable:', error.message);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
